import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import UserForm from '@/modules/user/components/UserForm.vue';
import { User } from '@/modules/user/User';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const store = useStore<AppStore>();
const authUser = computed(() => store.state.authenticatedUser);

const user = ref<Partial<User>>({
	type: authUser.value?.type,
	permissions: [],
	language: store.getters.userLanguage,
});

const saved = (user) => {
	Flash.success($gettext('Användare tillagd'));
	router.push({
		name: 'user.edit',
		params: { id: user.id },
	});
};

const cancel = () => {
	router.push({ name: 'user.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserForm, {
    "page-title": _unref($gettext)('Ny användare'),
    user: user.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "user"]))
}
}

})